import { useBrand } from '@bnnvara/brand';
import trimEnd from 'lodash/trimEnd';
import Router, { useRouter } from 'next/router';

import removeQueryParams from '../helpers/removeQueryParams';
import setQueryParams from '../helpers/setQueryParams';
import prepareHref from '../prepareHref';

const useLink = () => {
  const brand = useBrand();
  const router = useRouter();

  const goto = (href, options = null, type = 'push') => {
    if (!window) {
      return;
    }

    const { href: hrefObject, as } = prepareHref(href, brand);

    Router[type](hrefObject, as, options);
  };

  const createHref = (href, brandSlugs) => prepareHref(href, brand, brandSlugs);

  const isCurrent = (path) => {
    const exactMatch = ['', '/'].includes(path);
    const { as } = createHref(path);
    const { asPath } = router;

    const currentPathToMatch = trimEnd(asPath, '/');

    if (exactMatch) {
      return as === currentPathToMatch;
    }

    return currentPathToMatch.split('?')[0] === as.split('?')[0];
  };

  // Somehow the brand is not always available (e.g. when closing the account screens) through useBrand
  // If it is not available, we acquire the brand through the router
  const brandSlug = () => {
    const slug = router && router.query && router.query.brandSlug;
    return slug || 'portal';
  };

  return {
    goto,
    isCurrent,
    createHref,
    setQueryParams: setQueryParams(brand || { slug: brandSlug() }),
    removeQueryParams: removeQueryParams(brand || { slug: brandSlug() }),
  };
};

export default useLink;
